module.exports = __webpack_public_path__ + "media/images/ui-icons_777777_256x240-6d28e77d.png";